import { TournamentDrawsComponent } from './tournament-draws/tournament-draws.component';
import { StandingsComponent } from './standings/standings.component';
import { ParticipantListComponent } from './../../participant-list/participant-list.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TournamentDetailsComponent } from './tournament-details.component';
import { LiveScoreComponent } from './live-score/live-score.component';
import { AuthPassService as AuthPass } from '../../auth/auth-pass.service';
import { AuthGuardService as AuthGuard } from '../../auth/auth-guard.service';


const routes: Routes = [
    {
        path: '',
        component: TournamentDetailsComponent,
        children: [
            {
                path: 'live-score',
                component: LiveScoreComponent,
                data: {
                    type: 'live-score'
                }
            },
            {
                path: 'upcoming',
                component: LiveScoreComponent,
                data: {
                    type: 'upcoming'
                }
            },
            {
                path: 'completed',
                component: LiveScoreComponent,
                data: {
                    type: 'completed'
                }
            },
                        {
                path: 'draw',
                component: TournamentDrawsComponent,
                data: {
                    type: 'completed'
                }
            },
            {
                path: 'players',
                canActivate: [AuthGuard],
                component: ParticipantListComponent,
            },
            {
                path: 'standings',
                component: StandingsComponent,
            },
            {
                path: '',
                redirectTo: 'live-score',
                pathMatch: 'full'
            },
            {
                path: 'live-score/stream-view/:theme',
                component: LiveScoreComponent,
                canActivate: [AuthPass],
                data: {
                    type: 'live-score'
                }
            },
        ]
    },
    {
        path: '',
        redirectTo: 'live-score',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TournamentDetailsRoundModule { }
